import { Grid, Checkbox, Button } from "@mui/material";
import styled from "styled-components";
import deleteIcon from "../../../components/content/icons/delete.svg";

interface IProps {
  checked: boolean;
  onCheckAll: () => any;
  onDelete: () => any;
  checkCount: number;
}

const Header = styled.p`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const RuleHeader = ({ checked, onCheckAll, onDelete, checkCount }: IProps) => {
  return (
    <div>
      {checkCount > 0 && (
        <Grid container style={{ backgroundColor: "black", alignItems: "center" }}>
          <Grid item xs={4} style={{ color: "white", paddingLeft: "10px" }}>
            <Header>{checkCount} items selected</Header>
          </Grid>
          <Grid
            item
            xs={8}
            style={{ display: "flex", justifyContent: "right", alignItems: "center", paddingRight: "10px" }}
          >
            <Button onClick={onDelete} style={{ color: "white" }}>
              <img src={deleteIcon} alt="delete" height="18px" />
              &nbsp;Delete rules
            </Button>
          </Grid>
        </Grid>
      )}
      <Grid container style={{ backgroundColor: "#eeeeee", alignItems: "center" }}>
        <Grid item xs={1} style={{ display: "flex", justifyContent: "center", alignItems: "right" }}>
          &nbsp; &nbsp; &nbsp;
          <Checkbox size="small" style={{ color: "#414141" }} onClick={() => onCheckAll()} checked={checked} />
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            display: "flex",
            marginLeft: "-10px",
            marginRight: "10px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Header>Type</Header>
        </Grid>
        {/*
        <Grid item xs={1} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Header>Rule</Header>
        </Grid>
      */}
        <Grid item xs={6} style={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
          <Header>Old Site</Header>
        </Grid>
        <Grid
          item
          xs={1}
          style={{
            display: "flex",
            marginLeft: "-20px",
            marginRight: "10px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Header>Action</Header>
        </Grid>
        <Grid item xs={2} style={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
          <Header>Updated Site</Header>
        </Grid>
      </Grid>
    </div>
  );
};
